const Header = (()=>{

    const _HeaderConfig = ()=>{
        let lastScrollTop = 0;
        //Event scroll
        window.addEventListener('scroll', function() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const header = document.querySelector('header');
            //Validate scroll
            if (scrollTop > lastScrollTop) {
                header.classList.add('scroll');
            } else if (scrollTop < lastScrollTop) {
                header.classList.remove('scroll');
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });
    }

    const _HeaderHamburger = ()=>{
        const hamburgerButton = document.querySelector('header .header__hamburger');

        hamburgerButton.addEventListener('click', (e)=>{
            hamburgerButton.classList.toggle('active');
            e.target.closest('header').classList.toggle('active');
        });
    }

    const _HeaderTitle = ()=>{
        const blackTitle = document.querySelector('#black-title');
        const fontTile = document.querySelector('#family-title');
        const hiddenTitle = document.querySelector('#hidden-title');
        const noPadding = document.querySelector('#no-padding');

        setTimeout(()=>{
            blackTitle && (document.querySelector('#block-sabios-theme-page-title h1').style.color = "#000");
            hiddenTitle && (document.querySelector('#block-sabios-theme-page-title h1').style.display = "none");
            noPadding && (document.querySelector('main').style.paddingBottom = 0);
            fontTile && (
                    document.querySelector('#block-sabios-theme-page-title h1').style.fontFamily = "sui-generis",
                    document.querySelector('#block-sabios-theme-page-title h1').classList.add('italic')
                );
        }, 100);
    }

    const _HeaderLoader = ()=>{
        const loader = document.querySelector('.loader');
        const stars = document.querySelector('.stars');
        setTimeout(()=>{
            loader.classList.add('disabled');
            // stars.classList.add('disabled');
        },1000);
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { _HeaderConfig(); } catch (error) { }
            try { _HeaderHamburger(); } catch (error) { }
            try { _HeaderTitle(); } catch (error) { }
            try { _HeaderLoader(); } catch (error) { }
        }
    }
})();

/*
*Load global functions
*/
const loadHeaderHandlers = ()=>{
    Header.setHandleEvent();
}

export { loadHeaderHandlers }